import { TopKArray } from "./topKArray.js";
class TopKState {
  #multiplicities = /* @__PURE__ */ new Map();
  #topK;
  constructor(topK) {
    this.#topK = topK;
  }
  get size() {
    return this.#topK.size;
  }
  get isEmpty() {
    return this.#multiplicities.size === 0 && this.#topK.size === 0;
  }
  /**
   * Process an element update (insert or delete based on multiplicity change).
   * Returns the changes to the topK window.
   */
  processElement(key, value, multiplicity) {
    const { oldMultiplicity, newMultiplicity } = this.#updateMultiplicity(
      key,
      multiplicity
    );
    if (oldMultiplicity <= 0 && newMultiplicity > 0) {
      return this.#topK.insert([key, value]);
    } else if (oldMultiplicity > 0 && newMultiplicity <= 0) {
      return this.#topK.delete([key, value]);
    }
    return { moveIn: null, moveOut: null };
  }
  /**
   * Move the topK window. Only works with TopKArray implementation.
   */
  move(options) {
    if (!(this.#topK instanceof TopKArray)) {
      throw new Error(
        `Cannot move B+-tree implementation of TopK with fractional index`
      );
    }
    return this.#topK.move(options);
  }
  #updateMultiplicity(key, multiplicity) {
    if (multiplicity === 0) {
      const current = this.#multiplicities.get(key) ?? 0;
      return { oldMultiplicity: current, newMultiplicity: current };
    }
    const oldMultiplicity = this.#multiplicities.get(key) ?? 0;
    const newMultiplicity = oldMultiplicity + multiplicity;
    if (newMultiplicity === 0) {
      this.#multiplicities.delete(key);
    } else {
      this.#multiplicities.set(key, newMultiplicity);
    }
    return { oldMultiplicity, newMultiplicity };
  }
}
function handleMoveIn(moveIn, result) {
  if (moveIn) {
    const [[key, value], index] = moveIn;
    result.push([[key, [value, index]], 1]);
  }
}
function handleMoveOut(moveOut, result) {
  if (moveOut) {
    const [[key, value], index] = moveOut;
    result.push([[key, [value, index]], -1]);
  }
}
export {
  TopKState,
  handleMoveIn,
  handleMoveOut
};
//# sourceMappingURL=topKState.js.map
